import { render, staticRenderFns } from "./ResizeImageTest.vue?vue&type=template&id=df96979c&lang=pug"
import script from "./ResizeImageTest.vue?vue&type=script&lang=ts"
export * from "./ResizeImageTest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports